import React from "react";
import { Input, Button } from "antd";
import NumberFormat from "react-number-format";
import { validateBr } from "js-brasil";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";

const InputCPF = ({
  value = "",
  onSearch,
  onClear,
  showSearch = true,
  ...props
}) => {
  // controla a ação da lupa
  if (showSearch && !props.readOnly) {
    props.onSearch = validateBr.cpf(value) ? onSearch : undefined;
  }

  props.enterbutton = (
    <Button icon={props.readOnly ? <CloseOutlined /> : <SearchOutlined />} />
  );

  return (
    <NumberFormat
      {...props}
      value={value}
      customInput={showSearch && !props.readOnly ? Input.Search : Input}
      format="###.###.###-##"
    />
  );
};

InputCPF.Validator = (_, value = "") =>
  value.replace(/\D/g, "").length < 11 || validateBr.cpf(value)
    ? Promise.resolve()
    : Promise.reject(new Error("CPF inválido"));

export default InputCPF;
